import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faCloudDownload, faRefresh } from "@fortawesome/free-solid-svg-icons";

import TobNavBar from "../../../DashBaord/Top_navbar";
import { a11yProps } from "../../../../components/common";
import { usePermissions } from "../../../../controllers/PermissionContext";
import { SMART_RTP_TABS } from "../config";

export default function SmartRtpLayout({
  title,
  activeKey,
  children,
  headerVariant = "simple",
  statusTabs = [],
  statusIndex = 0,
  onStatusChange = null,
  onFilter = null,
  onExport = null,
  onRefresh = null,
  showFilter = false,
  showExport = false,
  extraHeader = null,
  actions = null,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const PERMISSION = usePermissions("smartRtp");
  const moduleIndex = Math.max(
    SMART_RTP_TABS.findIndex((item) => item.key === activeKey),
    0
  );
  const canExport = PERMISSION?.fullAccess === "Y" || PERMISSION?.export === "Y";

  useEffect(() => {
    const allowed =
      PERMISSION?.fullAccess === "Y" ||
      PERMISSION?.list === "Y" ||
      PERMISSION?.view === "Y" ||
      PERMISSION?.reports === "Y" ||
      PERMISSION?.runtime === "Y";
    if (!allowed) {
      navigate("/dashboard");
    }
  }, [PERMISSION, navigate]);

  const renderModuleTabs = () => (
    <div className="inventory_all_tabs smart_rtp_header_tabs">
      <div className="all_tabs_value smart_rtp_tabs_wrap">
        <Tabs
          value={moduleIndex}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="smart rtp tabs"
          className="item_tabs_main_container"
          sx={{
            minHeight: 42,
            "& .MuiTabs-scrollButtons.Mui-disabled": { opacity: 0.3 },
            "& .MuiTab-root": {
              minWidth: "auto",
              whiteSpace: "nowrap",
              paddingLeft: "12px",
              paddingRight: "12px",
            },
          }}
        >
          {SMART_RTP_TABS.map((tab, index) => (
            <Tab
              key={tab.key}
              label={tab.label}
              className="tabs_main_contnet"
              {...a11yProps(index)}
              onClick={() => {
                if (location.pathname !== tab.path) {
                  navigate(tab.path);
                }
              }}
            />
          ))}
        </Tabs>
      </div>
      <div className="fa_filter_rating_review filter_img_and_add_btn_main smart_rtp_header_actions">
        {actions}
        {onRefresh ? (
          <div className="inventory_filter_div">
            <Link to={false} onClick={onRefresh}>
              <FontAwesomeIcon icon={faRefresh} />
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );

  const renderListHeader = () => (
    <div className="inventory_all_tabs">
      <div className="all_tabs_value">
        {statusTabs.length > 0 ? (
          <Tabs
            value={statusIndex}
            onChange={(event, value) => onStatusChange && onStatusChange(event, value)}
            aria-label="smart rtp status tabs"
            className="item_tabs_main_container"
          >
            {statusTabs.map((tab, index) => (
              <Tab
                key={`${tab.label}-${index}`}
                label={tab.label}
                className="tabs_main_contnet"
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        ) : null}
      </div>
      <div className="fa_filter_rating_review filter_img_and_add_btn_main">
        {extraHeader}
        {showFilter ? (
          <div className="inventory_filter_div" onClick={onFilter} style={{ cursor: "pointer" }}>
            <FontAwesomeIcon icon={faFilter} />
            <span className="filter_btn_invontry_rating_review">&nbsp;Filter</span>
          </div>
        ) : null}
        {showExport && canExport ? (
          <div className="inventory_filter_div" onClick={onExport} style={{ cursor: "pointer" }}>
            <FontAwesomeIcon icon={faCloudDownload} />
            <span className="filter_btn_invontry_rating_review">&nbsp;Export</span>
          </div>
        ) : null}
        {actions}
        {onRefresh ? (
          <div className="inventory_filter_div">
            <Link to={false} onClick={onRefresh}>
              <FontAwesomeIcon icon={faRefresh} />
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );

  const renderSimpleHeader = () =>
    actions || onRefresh ? (
      <div className="inventory_all_tabs">
        <div className="all_tabs_value" />
        <div className="fa_filter_rating_review filter_img_and_add_btn_main">
          {actions}
          {onRefresh ? (
            <div className="inventory_filter_div">
              <Link to={false} onClick={onRefresh}>
                <FontAwesomeIcon icon={faRefresh} />
              </Link>
            </div>
          ) : null}
        </div>
      </div>
    ) : null;

  return (
    <div className="container-fluid">
      <TobNavBar title={title} />
      <div className="inventory_tabs_main_div">
        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            {headerVariant === "module"
              ? renderModuleTabs()
              : headerVariant === "list"
                ? renderListHeader()
                : renderSimpleHeader()}
          </Box>
          <div className="mt-3">{children}</div>
        </Box>
      </div>
    </div>
  );
}
